document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.menu').forEach(menu => {
        const groups = menu.querySelectorAll('.group');
        let hideTimeout;

        function clearExistingTimeout() {
            if (hideTimeout) {
                clearTimeout(hideTimeout);
                hideTimeout = null;
            }
        }

        function hideAllSubmenusExcept(exceptSubmenu) {
            menu.querySelectorAll('.submenu').forEach(submenu => {
                if (submenu !== exceptSubmenu) {
                    submenu.style.display = 'none';
                }
            });
        }

        groups.forEach(group => {
            const submenu = group.querySelector('.submenu');
            if (!submenu) return;

            // Maus betritt group → submenu zeigen & andere schließen
            group.addEventListener('mouseenter', () => {
                clearExistingTimeout();
                hideAllSubmenusExcept(submenu);
                submenu.style.display = 'block';
            });

            // Maus verlässt group → prüfen ob komplett außerhalb menu
            group.addEventListener('mouseleave', (e) => {
                if (!menu.contains(e.relatedTarget)) {
                    clearExistingTimeout();
                    hideTimeout = setTimeout(() => {
                        submenu.style.display = 'none';
                    }, 1000);
                }
            });

            // Maus betritt submenu → Timeout abbrechen
            submenu.addEventListener('mouseenter', () => {
                clearExistingTimeout();
            });

            // Maus verlässt submenu → prüfen ob komplett außerhalb menu
            submenu.addEventListener('mouseleave', (e) => {
                if (!menu.contains(e.relatedTarget)) {
                    clearExistingTimeout();
                    hideTimeout = setTimeout(() => {
                        submenu.style.display = 'none';
                    }, 1000);
                }
            });
        });
    });
});
